var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"user"},[_c('NotificationList',{staticClass:"mr-8"}),_c('a',{on:{"click":_vm.logoutSystem}},[_c('r-icon',{attrs:{"icon":"exit","fill":"titanic","size":"20"}})],1),_c('div',{staticClass:"user__avatar"},[_c('r-icon',{attrs:{"fill":"amelie","icon":"avatar"}})],1),_c('span',[_vm._v(_vm._s(_vm.infoName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }